export default "__VITE_ASSET__CcNiNgVO__"